<template>
    <div class="card mt-1">
        <div class="card-body">
            <div class=" d-flex justify-content-between align-items-center p-2">
                <div class="transaction-title">Transaction</div>
                <button class="btn" @click="$emit('close')">
                    <img class="close-btn" src="@/assets/images/icon/close.png" />
                </button>
            </div>
            <div class="p-2 mt-3" >
                <div class="">
                    <div class="col-ref">Transaction type</div>
                    <div class="input-group">
                        <select id="transaction-type" class="form-control" v-model="transactionStore.filters.transactionType">
                            <option value="">All</option>
                            <option value="Sale">Sale</option>
                            <option value="Fee">Fee</option>
                            <option value="Refund">Refund</option>
                        </select>
                    </div>
                </div>
                <div class="mt-4">
                    <div class="col-ref">Settlement reference</div>
                    <input class="form-control col-input" type="text" placeholder="0123456" v-model="transactionStore.filters.reference" />
               </div>
               <div class="mt-4">
                    <div class="col-ref">From</div>
                    <Datepicker1 class="datepicker-here form-control digits" v-model="transactionStore.filters.fromDate" :time-format="'HH:mm:ss'"data-language="en" teleport-center  placeholder="Select date" />

               </div>
               <div class="mt-4">
                    <div class="col-ref">To</div>
                    <Datepicker1 class="datepicker-here form-control digits" v-model="transactionStore.filters.toDate" :time-format="'HH:mm:ss'"data-language="en" teleport-center placeholder="Select date" />
               </div>
        
               <button class="btn btn-search mt-4" @click="$emit('search')">
                Search
               </button>
            </div>
        </div>
    </div>

</template>

<script setup>
import { computed, reactive, watch, defineProps } from 'vue';
import Datepicker1 from '@vuepic/vue-datepicker';
import { useTransactionStore } from '@/store/driver/transaction';

const transactionStore = useTransactionStore();


</script>

<style scoped>
.card {
    position: absolute;
    top: 80px;
    left: 0;
    right: 0;
    z-index: 1;
    height: 100%;
    width: 100%; /* 設置寬度為 100% */
    overflow-y: auto;
    overflow-x: hidden; /* 防止左右滑動 */
    border-radius: 10px 10px 0px 0px;
}

.transaction-title{
    width: auto;
    height: 30px;

    /* Portal/Portal – H4 bold */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;

    /* 1E1E2D */
    color: #1E1E2D;
}

.close-btn {
    width: 22px;
    height: 22px;
}

.col-ref{
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: flex-end;

    color: #051C2C;
}

.col-input{
    height: 50px;
}

.btn-search{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 32px;
    gap: 10px;
    width: 100%;
    height: 46px;

    /* Green */
    background: #00C962;
    border-radius: 30px;
}

</style>

